import React from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '../../utils/cn';

const ViewLayout = ({ 
  title,
  subtitle,
  breadcrumbs = [],
  actions,
  stats,
  children,
  className = ''
}) => {
  return (
    <div className={cn('space-y-6 pb-20', className)}>
      {/* Header Section */}
      <div className="bg-white rounded-lg shadow-sm border p-6">
        {/* Breadcrumbs */}
        {breadcrumbs.length > 0 && (
          <nav className="flex items-center space-x-1 text-sm text-gray-500 mb-4">
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={index}>
                {index > 0 && <ChevronRight className="h-4 w-4" />}
                {crumb.href ? (
                  <button
                    onClick={crumb.onClick}
                    className="hover:text-gray-700 transition-colors"
                  >
                    {crumb.label}
                  </button>
                ) : (
                  <span className={index === breadcrumbs.length - 1 ? 'text-gray-900 font-medium' : ''}>
                    {crumb.label}
                  </span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}

        {/* Title and Actions Row */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            {subtitle && (
              <p className="text-gray-600 mt-1">{subtitle}</p>
            )}
          </div>
          
          {/* Action Buttons */}
          {actions && (
            <div className="flex flex-wrap gap-2">
              {actions}
            </div>
          )}
        </div>
      </div>

      {/* Stats Section */}
      {stats && (
        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-2">
          {stats}
        </div>
      )}

      {/* Content */}
      <div>
        {children}
      </div>
    </div>
  );
};

const ViewLayoutStat = ({ 
  title, 
  value, 
  subtitle, 
  icon: Icon, 
  color = 'blue'
}) => {
  const colorClasses = {
    blue: 'text-blue-600',
    green: 'text-green-600',
    orange: 'text-orange-600',
    purple: 'text-purple-600',
    red: 'text-red-600',
    gray: 'text-gray-600'
  };
  
  return (
    <div
      className="bg-white px-3 py-2 rounded border"
    >
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-3 flex-shrink-0">
          {Icon && <Icon className={cn('h-5 w-5', colorClasses[color])} />}
          <div className="text-lg font-bold text-gray-900">{value}</div>
        </div>
        <div className="flex-1 min-w-0 min-h-[2.5rem] flex flex-col justify-center">
          <div className="text-xs text-gray-600 truncate">{title}</div>
          {subtitle && (
            <div className="text-xs text-gray-500">{subtitle}</div>
          )}
        </div>
      </div>
    </div>
  );
};

ViewLayout.Stat = ViewLayoutStat;

export default ViewLayout;